import dayjs from "dayjs";
import { DATE_FORMAT } from "config/settings";

interface OptionResult {
  label: React.ReactNode;
  value: string;
  data: any;
}

export const createOptionCounterPartWithCycle = (item: any): OptionResult => {
  const cycleInfo = item?.cycle?.startDate
    ? `${dayjs(item.cycle.startDate).format(DATE_FORMAT)} - ${dayjs(item?.cycle?.endDate || item?.cycle?.limitDate).format(DATE_FORMAT)}`
    : "";

  return {
    label: (
      <div>
        <div>{`${item.code} - ${item.name}`}</div>
        {cycleInfo && <small>{cycleInfo}</small>}
      </div>
    ),
    value: item.code,
    data: item,
  };
};
